class CollectionListSwiper {
  constructor() {
    this.swipers = new Map();
    this.init();
  }

  init() {
    // Buscar todos los sliders de collection-list
    const sliders = document.querySelectorAll('.collection-list-slider-desktop-js');
    
    sliders.forEach((slider) => {
      this.initSwiper(slider);
    });

    // Escuchar cambios en el DOM para nuevas secciones
    this.observeDOMChanges();
  }

  initSwiper(sliderElement) {
    const sectionId = sliderElement.dataset.sectionId;
    
    // If a Swiper already exists for this section, destroy it
    if (this.swipers.has(sectionId)) {
      this.swipers.get(sectionId).destroy();
      this.swipers.delete(sectionId);
    }

    // Get configuration from data attributes
    const config = this.getSwiperConfig(sliderElement);
    
    // Buscar el contenedor de slides
    const slidesContainer = sliderElement.querySelector('.swiper');
    
    if (!slidesContainer) {
      console.warn(`No se encontró el contenedor de slides para la sección ${sectionId}`);
      return;
    }

    try {
      // Crear nueva instancia de Swiper
      const swiper = new Swiper(slidesContainer, config);
      
      // Guardar referencia
      this.swipers.set(sectionId, swiper);
      
      // Agregar eventos personalizados
      this.addCustomEvents(swiper, sliderElement, sectionId);
      
      console.log(`Collection List Swiper inicializado para la sección ${sectionId}`, config);
      
    } catch (error) {
      console.error(`Error al inicializar Collection List Swiper para la sección ${sectionId}:`, error);
    }
  }

  getSwiperConfig(sliderElement) {
    const sectionId = sliderElement.dataset.sectionId;
    
    // Get complete JSON configuration
    let swiperConfig = {};
    try {
      if (sliderElement.dataset.swiperConfig) {
        swiperConfig = JSON.parse(decodeURIComponent(sliderElement.dataset.swiperConfig));
      }
    } catch (error) {
      console.warn(`Error parsing swiper config for section ${sectionId}:`, error);
    }

    // Valores por defecto y desde data attributes
    const columnsDesktop = parseInt(sliderElement.dataset.columnsDesktop) || swiperConfig.columns_desktop || 3;
    const columnsMobile = parseInt(sliderElement.dataset.columnsMobile) || swiperConfig.columns_mobile || 1;
    const enableAutoplay = sliderElement.dataset.enableAutoplay === 'true';
    const autoplayDelay = parseInt(sliderElement.dataset.autoplayDelay) || swiperConfig.autoplay_delay || 5000;
    const pauseOnHover = sliderElement.dataset.pauseOnHover === 'true';
    const enableLoop = sliderElement.dataset.enableLoop === 'true';
    const spaceBetween = parseInt(sliderElement.dataset.spaceBetween) || swiperConfig.space_between || 30;

    // Base configuration for collection-list
    const config = {
      slidesPerView: columnsMobile,
      spaceBetween: spaceBetween,
      loop: enableLoop,
      centeredSlides: false,
      navigation: {
        nextEl: sliderElement.querySelector('.slider-button--next-desktop'),
        prevEl: sliderElement.querySelector('.slider-button--prev-desktop'),
      },
      scrollbar: {
        el: sliderElement.querySelector(`.collection-list-scrollbar-${sectionId}`),
        hide: false,
        draggable: true,
        dragSize: 'auto',
        snapOnRelease: true
      },
      breakpoints: {
        0: {
          slidesPerView: columnsMobile,
          spaceBetween: Math.max(spaceBetween - 10, 10)
        },
        768: {
          slidesPerView: Math.min(columnsMobile + 1, columnsDesktop),
          spaceBetween: Math.max(spaceBetween - 5, 15)
        },
        1024: {
          slidesPerView: columnsDesktop,
          spaceBetween: spaceBetween,
          centeredSlides: false
        }
      },
      // Callbacks
      on: {
        init: (swiper) => {
          this.onSwiperInit(swiper, sliderElement, sectionId);
        },
        slideChange: (swiper) => {
          this.onSlideChange(swiper, sliderElement, sectionId);
        }
      }
    };

    // Add autoplay if enabled
    if (enableAutoplay) {
      config.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: pauseOnHover
      };
    }

    return config;
  }

  addCustomEvents(swiper, sliderElement, sectionId) {
    // Custom event to update counters
    swiper.on('slideChange', () => {
      this.updateCounters(sliderElement, swiper);
    });

    // Event to pause/resume autoplay
    let swiperConfig = {};
    try {
      if (sliderElement.dataset.swiperConfig) {
        swiperConfig = JSON.parse(decodeURIComponent(sliderElement.dataset.swiperConfig));
      }
    } catch (error) {
      console.warn(`Error parsing swiper config for section ${sectionId}:`, error);
    }

    const pauseOnHover = sliderElement.dataset.pauseOnHover === 'true';
    
    if (pauseOnHover && swiper.autoplay) {
      sliderElement.addEventListener('mouseenter', () => {
        swiper.autoplay.stop();
      });
      
      sliderElement.addEventListener('mouseleave', () => {
        swiper.autoplay.start();
      });
    }

    // Add keyboard events for accessibility
    sliderElement.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        swiper.slidePrev();
      } else if (event.key === 'ArrowRight') {
        swiper.slideNext();
      }
    });
  }

  onSwiperInit(swiper, sliderElement, sectionId) {
    // Update initial counters
    this.updateCounters(sliderElement, swiper);
    
    // Emit custom event
    sliderElement.dispatchEvent(new CustomEvent('swiper:init', {
      detail: { swiper, sectionId }
    }));
  }

  onSlideChange(swiper, sliderElement, sectionId) {
    // Emit custom event
    sliderElement.dispatchEvent(new CustomEvent('swiper:slideChange', {
      detail: { 
        swiper, 
        sectionId,
        activeIndex: swiper.activeIndex,
        realIndex: swiper.realIndex
      }
    }));
  }

  updateCounters(sliderElement, swiper) {
    const currentCounter = sliderElement.querySelector('.slider-counter--current');
    const totalCounter = sliderElement.querySelector('.slider-counter--total');
    
    if (currentCounter) {
      currentCounter.textContent = swiper.realIndex + 1;
    }
    
    if (totalCounter) {
      totalCounter.textContent = swiper.slides.length;
    }
  }

  observeDOMChanges() {
    // Observe DOM changes to detect new sections
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Look for new sliders in the added node
            const newSliders = node.querySelectorAll ? 
              node.querySelectorAll('.collection-list-slider-desktop-js') : 
              (node.classList && node.classList.contains('collection-list-slider-desktop-js') ? [node] : []);
            
            newSliders.forEach((slider) => {
              this.initSwiper(slider);
            });
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Public methods for external control
  getSwiper(sectionId) {
    return this.swipers.get(sectionId);
  }

  destroySwiper(sectionId) {
    const swiper = this.swipers.get(sectionId);
    if (swiper) {
      swiper.destroy();
      this.swipers.delete(sectionId);
    }
  }

  destroyAll() {
    this.swipers.forEach((swiper, sectionId) => {
      swiper.destroy();
    });
    this.swipers.clear();
  }

  // Method to reinitialize a specific slider
  reinitSwiper(sectionId) {
    const sliderElement = document.querySelector(`[data-section-id="${sectionId}"].collection-list-slider-desktop-js`);
    if (sliderElement) {
      this.initSwiper(sliderElement);
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Check if Swiper is available
  if (typeof Swiper === 'undefined') {
    console.warn('Swiper is not loaded. Make sure to include the Swiper library.');
    return;
  }

  // Crear instancia global
  window.collectionListSwiper = new CollectionListSwiper();
});

// Also initialize on Shopify events
document.addEventListener('shopify:section:load', function(event) {
  if (window.collectionListSwiper) {
    const sliderElement = event.target.querySelector('.collection-list-slider-desktop-js');
    if (sliderElement) {
      window.collectionListSwiper.initSwiper(sliderElement);
    }
  }
});

document.addEventListener('shopify:section:unload', function(event) {
  if (window.collectionListSwiper) {
    const sectionId = event.target.querySelector('.collection-list-slider-desktop-js')?.dataset.sectionId;
    if (sectionId) {
      window.collectionListSwiper.destroySwiper(sectionId);
    }
  }
}); 